<!--
  创建时间：2024/8/21 18:31
  创建人：toyehuang
  文件描述：TabNews
-->

<template>
  <div class="news f-b-c">
    <image-news :list="imgNewsList" />
    <div class="tab-news f-column-b">
      <div class="tab-head">
        <ul class="tabs flex">
          <li v-for="menu in menuTabs" :key="menu.code" class="tabs-item" :class="{active: activeTab === menu.code}" @click="activeTab = menu.code">{{ menu.title }}</li>
        </ul>
        <a :href="moreBtnUrl" class="a-btn more-btn" target="_blank">更多 &gt;</a>
      </div>
      <ul class="news-list">
        <li v-for="data in dataList[activeTab]" :key="data.id" class="news-item f-b-c">
          <Link class="f-b-c" :to="{path:`/info/detail/${activeTab}`, query: {id: data.id}}" :title="data.title" target="_blank">
            <span class="text-cut">{{ data.title }}</span>
            <span class="time fc99 pl-10">{{ data.releaseTime | formatterDate }}</span>
          </Link>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import ImageNews from "@/views/home/components/ImageNews.vue";
import { AD_CODE, NAV_MENU_CODE } from "@/utils/constant";
import infoApi from "@/api/information";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import adApi from "@/api/ad";

export default {
  name: "TabNews",
  components: { ImageNews, Link },
  props: {
  },
  data() {
    return {
      dataList: {
        [NAV_MENU_CODE.PLATFORM_UPDATES]: [],
        [NAV_MENU_CODE.NOTICES]: []
      },
      imgNewsList: [],
      activeTab: NAV_MENU_CODE.PLATFORM_UPDATES,
      menuTabs: [
        { title: "平台动态", code: NAV_MENU_CODE.PLATFORM_UPDATES },
        { title: "通知公告", code: NAV_MENU_CODE.NOTICES }
      ],
      NAV_MENU_CODE
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return "/info/list/" + this.activeTab
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
    this.getAdList()
  },
  // 方法集合
  methods: {
    loadListData() {
      const params = {
        pageNo: 1,
        pageSize: 8
      };
      Promise.all([
        infoApi.page({ ...params, columnId: this.$getMenuIdByCode(NAV_MENU_CODE.PLATFORM_UPDATES) }),
        infoApi.page({ ...params, columnId: this.$getMenuIdByCode(NAV_MENU_CODE.NOTICES) })
      ]).then(([platformUpdates = {}, notices = {}]) => {
        this.dataList = {
          [NAV_MENU_CODE.PLATFORM_UPDATES]: platformUpdates.data?.list ?? [],
          [NAV_MENU_CODE.NOTICES]: notices.data?.list ?? []
        }
      })
    },
    getAdList() {
      adApi.page({ pageNo: 1, pageSize: 5, type: AD_CODE.AD_NEWS }).then((res) => {
        this.imgNewsList = res.data.list;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.tab-news{
  height: 289px;
  width: 453px;
	padding-left: 15px;
	padding-right: 20px;
	overflow: hidden;
	.tab-head{
		height: 30px;
		border-bottom: 1px solid #ddd;
		position: relative;
		line-height: 1;
		.tabs{
			height: 100%;
			.tabs-item{
				height: 100%;
				width: 64px;
				font-size: 16px;
				font-weight: bold;
				color: #333;
				position: relative;
				margin-right: 20px;
				cursor: pointer;
				&:hover{
					color: $--color-primary;
				}
				&.active:after{
					content: "";
					display: block;
					position: absolute;
					width: 64px;
					height: 2px;
					left: 0;
					bottom: -1px;
					background-color: $--color-primary;
				}
			}
		}
		.more-btn{
			position: absolute;
			top: 2px;
			right: 0;
			z-index: 999;
		}
	}
	.news-list{
		flex: 1;
		min-height: 0;
		width: 100%;
		padding-top: 5px;
		.news-item{
			position: relative;
			padding-left:14px;
			line-height: 33px;
			&::before{
				content: '';
				display: block;
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: #999;
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
			}
			a{
				width: 100%;
				color: #333;
				.text-cut{
					flex: 1;
					display: block;
				}
			}
			&:hover{
				&:before{
					background-color: $--color-primary;
				}
				a{
					color: $--color-primary;
				}
			}
		}
	}
}
</style>
